import { styled } from "styled-components";
import BlurScreen from "../BlurScreen";

const Spinner = () => (
	<StyledSpinner viewBox="0 0 50 50">
		<circle
			className="path"
			cx="25"
			cy="25"
			r="20"
			fill="none"
			strokeWidth="4"
		/>
	</StyledSpinner>
);

const StyledSpinner = styled.svg`
  	animation: showDelay 1s forwards, rotate 2s linear infinite;
	animation-delay: 1s;
  	width: 50px;
  	height: 50px;
	opacity: 0.1;
  
  	& .path {
		stroke: var(--d8s-progress);
		stroke-linecap: round;
		animation: dash 1.5s ease-in-out infinite;
  	}
	
	@keyframes showDelay {
		from {
			opacity: 0.1;
		}
		to {
			opacity: 1;
		}
	}
  	@keyframes rotate {
		100% {
			transform: rotate(360deg);
		}
	}
  	@keyframes dash {
		0% {
		  stroke-dasharray: 1, 150;
		  stroke-dashoffset: 0;
		}
		50% {
		  stroke-dasharray: 90, 150;
		  stroke-dashoffset: -35;
		}
		100% {
		  stroke-dasharray: 90, 150;
		  stroke-dashoffset: -124;
		}
	}
`;

export const LoadSpinner = () =>
	<BlurScreen>
		<Spinner />
	</BlurScreen>
;

export default LoadSpinner;
